import {PlainTextOrHtml} from '@wallaby-ui/core';
import {ICellRendererParams} from 'ag-grid-community';
import classNames from 'classnames';
import * as React from 'react';
import {injectIntl, WrappedComponentProps} from 'react-intl';

import styles from './IconSpanWrapperLinkFormatter.less';
import stylesLinkFormatter from './LinkFormatter.less';
import {getRouteAndIconName} from 'src/js/containers/encounter/encounter_helpers';
import {EntityLink} from 'src/js/containers/file/components/EntityLink';
import {baseDashboardEncounterLinkFormatterParams} from 'src/js/lib/raw_rendering/base_dashboard_encounter_link_formatter_params';

/**
 * Renders Encounter Link - link to the main document representing type of encounter
 */

type OwnProps = ICellRendererParams;

type Props = OwnProps & WrappedComponentProps;

class DashboardEncounterLinkFormatter extends React.PureComponent<Props> {
  static displayName = 'EncounterLinkFormatter';

  render() {
    const {intl} = this.props;
    const {id, label, searchParams, titleText, encounterType} =
      baseDashboardEncounterLinkFormatterParams(this.props, {intl});
    const {iconName, route} = getRouteAndIconName(encounterType);

    return (
      <span className={styles.dlSpanWrapper}>
        {iconName && <i className={classNames(iconName, styles.dlIconLink)} />}
        {
          <div className={stylesLinkFormatter.dlLinkFormatter}>
            <EntityLink
              id={id}
              route={route}
              titleText={titleText}
              searchParams={searchParams}
              suppressPadding
            >
              <PlainTextOrHtml
                text={label}
                showHtml
                className={stylesLinkFormatter.dlLinkFormatterText}
              />
            </EntityLink>
          </div>
        }
      </span>
    );
  }
}

export default injectIntl(DashboardEncounterLinkFormatter);
